/**
 * Momentum Indicator
 *
 * Measures the rate of price change over `period` bars.
 * Momentum = Close − Close[period bars ago].
 * Zero line crossovers signal trend changes.
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { getSource } from "./sma";

export const momentumIndicator: IndicatorDefinition = {
  id: "momentum",
  name: "Momentum",
  shortName: "MOM",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 10, min: 1, max: 200 },
    { key: "source", label: "Source", type: "select", default: "close", options: [
      { label: "Close", value: "close" }, { label: "Open", value: "open" },
      { label: "High", value: "high" }, { label: "Low", value: "low" },
    ]},
    { key: "color", label: "Color", type: "color", default: "#3F51B5" },
  ],
  plots: [
    { key: "momentum", label: "MOM", color: "#3F51B5", style: "line", lineWidth: 2, priceScaleId: "momentum" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period, source = "close" } = params;
    const src = getSource(candles, source);
    const data: { time: number; value: number }[] = [];

    for (let i = period; i < src.length; i++) {
      data.push({ time: candles[i].time, value: src[i] - src[i - period] });
    }

    return [{ key: "momentum", data }];
  },
};
